<template>
  <list-template :classCustom="'list-job'">
    <template #header>
      <main-header>
        <template #filterByStatus>
          <div class="leftSection">
            <div
              class="header-title wrapper-content__main font-size__large font-weight__bold"
            >
              <h3 class="font-weight__bold">
                Báo cáo tổng hợp tháng
              </h3>
            </div>
          </div>
        </template>
      </main-header>
    </template>
    <template #view>
      <div class="view">
        <list-template :classCustom="'list-docs wrapper-content__main'">
          <template #subHeader>
            <sub-header>
              <template #content>
                <el-form
                  ref="form"
                  :model="form"
                  label-position="top"
                  class="input-no__label"
                  style="width: 90%;"
                >
                  <el-row :gutter="24" class="leftSection margin-right-10">
                    <el-col
                      :span="8"
                      class="flex-row flex-left__top custom-label__input"
                    >
                      <span class="label-input width__auto">Đơn vị</span>
                      <el-select
                        v-model="form.deptId"
                        class="style-fullWidth input-none__border has-border__bottom"
                        size="medium"
                      >
                        <el-option
                          v-for="item in departments"
                          :key="item.id"
                          :label="item.deptName"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-col>

                    <el-col
                      :span="5"
                      class="flex-row flex-left__top custom-label__input"
                    >
                      <span class="label-input width__auto">Trạng thái</span>
                      <el-select
                        v-model="status"
                        class="style-fullWidth input-none__border has-border__bottom"
                        size="medium"
                        multiple
                      >
                        <el-option
                          v-for="item in statusList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-col>

                    <el-col
                      :span="9"
                      class="flex-row flex-left__top custom-label__input"
                    >
                      <span class="label-input width__auto"
                      >Khoảng thời gian</span
                      >

                      <el-date-picker
                        v-model="dateRange"
                        type="daterange"
                        format="dd/MM/yyyy"
                        class="style-fullWidth input-border__bottom input-border__radius__0"
                        :picker-options="dateQuickFilterOption"
                        range-separator="_"
                        start-placeholder="_"
                        end-placeholder="_"
                        align="right"
                        :clearable="false"
                        @change="dateRangeChanged"
                        size="medium"
                      ></el-date-picker>
                    </el-col>

                    <el-col
                      :span="2"
                      class="flex-row flex-left__top custom-label__input"
                    >
                      <el-button
                        class="btnSolid__blue"
                        size="medium"
                        @click="exportReport"
                      >
                        <i class="fa fa-table" aria-hidden="true"></i>
                        &nbsp;Xem báo cáo
                      </el-button>

                      <el-button
                        class="btnSolid__blue"
                        size="medium"
                        @click="exportReportExcel"
                      >
                        <i class="fa fa-file-excel" aria-hidden="true"></i>
                        &nbsp;Xuất Excel
                      </el-button>
                    </el-col>
                  </el-row>
                </el-form>
              </template>
            </sub-header>
          </template>
          <template #body>
            <template>
              <div class="barChart" ref="barChartContainerDiv">
                <el-table
                  v-if="rerenderFlag"
                  :data="items"
                  class="style-fullWidth"
                  highlight-current-row
                  :height="chartSize.height"
                  @sort-change="doSort"
                  :default-sort="convertToTableSortEvent()"
                >
                  <el-table-column type="index" fixed></el-table-column>

                  <el-table-column property="taskStatus" min-width="40" fixed>
                    <template slot-scope="scope">
                      <el-tooltip
                        :content="getTaskStatusLabel(scope.row)"
                        placement="top"
                      >
                        <task-status-icon :taskStatus="scope.row.taskStatus"/>
                      </el-tooltip>
                    </template>
                  </el-table-column>

                  <el-table-column
                    property="taskTitle"
                    label="Tiêu đề"
                    min-width="230"
                    fixed
                    sortable
                  >
                  </el-table-column>

                  <el-table-column
                    property="taskDetail"
                    label="Mô tả"
                    min-width="240"
                  >
                    <template slot-scope="scope">
                      <el-tooltip
                        :disabled="
                          scope.row.taskDetail === scope.row.taskDetailShort
                        "
                        :content="scope.row.taskDetail"
                        placement="top"
                        :open-delay="300"
                      >
                        <span class="break-word">{{
                            scope.row.taskDetailShort
                          }}</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>

                  <el-table-column
                    property="assignerName"
                    label="Người giao"
                    min-width="150"
                    sortable
                    :filters="assignerNameFilters"
                    :filter-method="
                      (value, row) => filterMethod(value, row, 'assignerId')
                    "
                    show-overflow-tooltip
                  >
                  </el-table-column>

                  <el-table-column
                    property="receiverName"
                    label="Người thực hiện"
                    min-width="150"
                    sortable
                    :filters="receiverNameFilters"
                    :filter-method="
                      (value, row) => filterMethod(value, row, 'receiverId')
                    "
                    show-overflow-tooltip
                  >
                  </el-table-column>

                  <el-table-column
                    property="startDate"
                    label="Ngày bắt đầu"
                    min-width="120"
                    sortable
                  >
                    <template slot-scope="scope">
                      <i class="el-icon-time"></i>
                      <span>{{
                          scope.row.startDate
                            | dateFormatter({
                            dateFormat: "DD/MM/YYYY",
                            nullValue: "-"
                          })
                        }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    property="deadline"
                    label="Hạn hoàn thành"
                    min-width="130"
                    sortable
                  >
                    <template slot-scope="scope">
                      <i class="el-icon-time"></i>
                      <span>{{
                          scope.row.deadline
                            | dateFormatter({
                            dateFormat: "DD/MM/YYYY",
                            nullValue: "-"
                          })
                        }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    property="completionTime"
                    label="Ngày hoàn thành"
                    min-width="135"
                    sortable
                  >
                    <template slot-scope="scope">
                      <div v-if="scope.row.completionTime">
                        <i class="el-icon-time"></i>
                        <span>{{
                            scope.row.completionTime
                              | dateFormatter({
                              dateFormat: "DD/MM/YYYY",
                              nullValue: "-"
                            })
                          }}</span>
                      </div>
                      <span v-else>-</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    property="evaluationPoint"
                    label="Đánh giá"
                    align="center"
                    min-width="110"
                    sortable
                    :filters="evaluationFilters"
                    :filter-method="
                      (value, row) => filterMethod(value, row, 'evaluation')
                    "
                  >
                    <template slot-scope="scope">
                      <div
                        :class="[
                          `jobInfoRate rateLvl-${scope.row.evaluationPoint}`
                        ]"
                        v-if="scope.row.evaluationPoint != null"
                      >
                        <span>{{
                            getEvaluationPointLabel(scope.row.evaluationPoint) ||
                            "-"
                          }}</span>
                        <div>
                          {{ scope.row.evaluationPoint }}
                          <i class="fas fa-star"></i>
                        </div>
                      </div>
                      <span v-else>-</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    property="manday"
                    label="Nhân công"
                    min-width="50"
                    align="right"
                  >
                    <template slot-scope="scope"
                    >{{ scope.row.manday || "-" }}
                    </template>
                  </el-table-column>

                  <el-table-column
                    property="completionPercent"
                    label="Tiến độ"
                    min-width="100"
                    align="right"
                    sortable
                  >
                    <template slot-scope="scope">
                      <div class="flex-row flex__left">
                        <el-progress
                          type="circle"
                          :percentage="scope.row.completionPercent"
                          color="#007aff"
                          :stroke-width="4"
                          size="mini"
                          :width="20"
                          class="margin-right-10"
                          :status="'success'"
                        ></el-progress>
                        {{ scope.row.completionPercent }}%
                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column
                    label="Quá hạn"
                    align="right"
                    sortable
                    :sort-method="
                      (item1, item2) => sortMethod(item1, item2, 'expireDay')
                    "
                    min-width="90"
                  >
                    <template slot-scope="scope">
                      {{ calculateExpireDays(scope.row) || "-" }}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </template>
        </list-template>
      </div>
    </template>
  </list-template>
</template>

<script>
  import moment from "moment-business-days";
  import MainHeader from "../../../components/header/main-header";
  import SubHeader from "../../../components/main/sub-header";
  import constants from "../../../constants";
  import dateUtils from "../../../dateUtils";
  import dateFormatter from "../../../filters/dateFormatter";
  import departmentService from "../../../services/departmentService";
  import h from "../../../services/h";
  import tkTaskViewService from "../../../services/tkTaskViewService";
  import utils from "../../../services/utils";
  import ListTemplate from "../../common/list";
  import TaskStatusIcon from "../../job/task-status-icon";
  import DocInBookReportCard from "../docInBookReportCard";
  import TkReportCard from "../tk-report-card";
  import vbDocReportCard from "../vbDocReportCard";
  import TienDoHoanThanhCvChart from "./tien-do-hoan-thanh-cv-chart";

  export default {
    name: "bao-cao-tong-hop-thang",
    components: {
      TaskStatusIcon,
      TienDoHoanThanhCvChart,
      SubHeader,
      MainHeader,
      ListTemplate,
      TkReportCard,
      DocInBookReportCard,
      vbDocReportCard
    },

    filters: {dateFormatter},

    computed: {
      userDeptRole() {
        return this.$store.getters.userDeptRole;
      },

      userDeptRoleId() {
        return this.$route.params.userDeptRoleId;
      }
    },

    watch: {
      items() {
        this.initItems();
        this.initFilters();
        //trick để render lại tablet;
        this.rerenderFlag = false;
        this.$nextTick(() => (this.rerenderFlag = true));
      }
    },

    data() {
      return {
        form: {
          fromDate: null,
          toDate: null,
          deptId: null
        },
        dateRange: null,
        dateQuickFilterOption: null,
        REPORT: constants.REPORT,
        departments_: null,
        departments: null,
        statusList: constants.TASK_STATUS_V2,
        status: [],
        items: [],
        chartSize: {
          heigth: 100
        },
        assignerNameFilters: null,
        receiverNameFilters: null,
        evaluationFilters: null,
        rerenderFlag: true, //trick để thực hiện render lại table,
        sort: null,
        order: null,
      };
    },

    created() {
      if (!this.userDeptRole) return;
      this.initEvaluationFilters();
      this.loadDepartments().then(() => {
        this.initDateQuickFilterOption();
        this.initQuery();
        this.exportReport();
      });
    },

    mounted() {
      this.calculateChartSize();
    },

    methods: {

      convertToTableSortEvent() {
        return utils.convertToTableSortEvent({sort: this.sort, order: this.order});
      },

      doSort(event) {
        let {sort, order} = utils.convertTableSortEvent(event);
        this.sort = sort;
        this.order = order;
      },

      initItems() {
        h.each(
          this.items,
          item =>
            (item.taskDetailShort = this.getShortString(item.taskDetail, {
              maxLength: 200
            }))
        );
      },

      getShortString(str, option) {
        return utils.getShortString(str, option);
      },

      filterMethod(value, row, field) {
        let value_;
        switch (field) {
          case "evaluation":
            return value.indexOf(row.evaluationPoint) !== -1;
          default:
            value_ = row[field];
            return value_ === value;
        }
      },

      initEvaluationFilters() {
        this.evaluationFilters = [
          {value: [1, 2, 3, 4], text: "Yếu kém (1-4)"},
          {value: [5], text: "Chưa đạt yêu cầu (5)"},
          {value: [6, 7], text: "Đạt yêu cầu (6-7)"},
          {value: [8, 9], text: "Tốt (8-9)"},
          {value: [10], text: "Xuất sắc (10)"}
        ];
      },

      initFilters() {
        this.assignerNameFilters = this.collectFiltersSet(
          tkTaskView => tkTaskView.assignerId,
          tkTaskView => tkTaskView.assignerName
        );
        this.receiverNameFilters = this.collectFiltersSet(
          tkTaskView => tkTaskView.receiverId,
          tkTaskView => tkTaskView.receiverName
        );
      },

      collectFiltersSet(getValueFn, getTextFn) {
        let filters = [];
        let values = [];
        h.each(this.items, item => {
          let value = getValueFn(item);
          if (values.indexOf(value) === -1) {
            values.push(value);
            filters.push({value: value, text: getTextFn(item)});
          }
        });
        filters.sort((item1, item2) => item1.text.localeCompare(item2.text));
        return filters;
      },

      getTaskStatusLabel(tkTaskView) {
        switch (tkTaskView.taskStatus) {
          case constants.TASK_STATUS.DANG_THUC_HIEN:
            return "Đang thực hiện";
          case constants.TASK_STATUS.HOAN_THANH:
            return "Chờ đánh giá";
          case constants.TASK_STATUS.KET_THUC:
            return "Kết thúc";
          case constants.TASK_STATUS.CHO_PHE_DUYET_DK:
            return "Chờ phê duyệt đăng ký";
          case constants.TASK_STATUS.HUY_PHE_DUYET_DK:
            return "Từ chối";
          case constants.TASK_STATUS.HUY:
            return "Hủy";
          case constants.TASK_STATUS.TAM_DUNG:
            return "Tạm dừng";
          default:
            return "-";
        }
      },

      sortMethod(item1, item2, field) {
        switch (field) {
          case "expireDay":
            return (
              this.calculateExpireDays(item1) - this.calculateExpireDays(item2)
            );
          default:
            return 0;
        }
      },

      calculateExpireDays(tkTaskView) {
        let status = tkTaskView.taskStatus;

        if (
          (status !== constants.TASK_STATUS.DANG_THUC_HIEN &&
            status !== constants.TASK_STATUS.HOAN_THANH &&
            status !== constants.TASK_STATUS.KET_THUC) ||
          !tkTaskView.deadline
        )
          return null;

        let completionTime = constants.TASK_STATUS.DANG_THUC_HIEN == status ?
          new Date() : tkTaskView.completionTime;

        if (!completionTime) return 0;

        let completionTime_ = moment(completionTime).startOf("day");
        let deadline_ = moment(tkTaskView.deadline).startOf("day");

        return completionTime_.diff(deadline_, "days");
      },

      calculateChartSize() {
        this.chartSize.height = this.$refs.barChartContainerDiv.clientHeight;
      },

      getEvaluationPointLabel(evaluationPoint) {
        let point = h.find(
          constants.EVALUATION_POINT,
          point => point.score === evaluationPoint
        );
        return point ? point.shortValue : null;
      },

      loadDepartments() {
        return departmentService
          .findAllTaskBaoCaoTongHopThangReport()
          .then(response => {
            this.departments_ = response.data;
            this.departments = [];
            if (this.departments_.length > 1) {
              this.departments.push({id: "all", deptName: "Tất cả"});
            }
            this.departments.push(
              ...h.collect(this.departments_, item => {
                return {id: item.id, deptName: item.deptName};
              })
            );
          });
      },

      initDateQuickFilterOption() {
        this.dateQuickFilterOption = {
          shortcuts: [
            {
              text: "Tháng này",
              onClick(picker) {
                picker.$emit(
                  "pick",
                  dateUtils.getDatesByQuickFilter(
                    constants.DATE_QUICK_FILTER.CODE.THIS_MONTH_2
                  )
                );
              }
            },
            {
              text: "Tháng trước",
              onClick(picker) {
                picker.$emit(
                  "pick",
                  dateUtils.getDatesByQuickFilter(
                    constants.DATE_QUICK_FILTER.CODE.LAST_MONTH
                  )
                );
              }
            },
            {
              text: "Năm nay",
              onClick(picker) {
                picker.$emit(
                  "pick",
                  dateUtils.getDatesByQuickFilter(
                    constants.DATE_QUICK_FILTER.CODE.NAM_NAY
                  )
                );
              }
            }
          ]
        };
      },

      initQuery() {
        this.form.fromDate = this.$route.query.fromDate
          ? parseInt(this.$route.query.fromDate)
          : null;
        this.form.toDate = this.$route.query.toDate
          ? parseInt(this.$route.query.toDate)
          : undefined;
        this.form.deptId =
          this.$route.query.deptId ||
          (this.departments_ && this.departments_.length > 1
            ? "all"
            : this.userDeptRole.deptId); //set default là đơn vị của vai trò đang đăng nhập
        this.initDateRange();
      },

      initDateRange() {
        if (this.form.fromDate && this.form.toDate) {
          this.dateRange = [
            dateUtils.toMoment(this.form.fromDate),
            dateUtils.toMoment(this.form.toDate)
          ];
        } else {
          this.dateRange = dateUtils.getDatesByQuickFilter(
            constants.DATE_QUICK_FILTER.CODE.THIS_MONTH_2
          );
          let defaultTimeRange = dateUtils.getTimesByQuickFilter(
            constants.DATE_QUICK_FILTER.CODE.THIS_MONTH_2
          );
          this.form.fromDate = defaultTimeRange[0];
          this.form.toDate = defaultTimeRange[1];
          this.storeParamsAtUrl();
        }
      },

      dateRangeChanged() {
        this.form.fromDate =
          this.dateRange && this.dateRange[0]
            ? this.dateRange[0].getTime()
            : undefined;
        this.form.toDate =
          this.dateRange && this.dateRange[1]
            ? this.dateRange[1].getTime()
            : undefined;
      },

      buildQuery() {
        return {
          fromDate: this.form.fromDate || undefined,
          toDate: this.form.toDate || undefined,
          deptId: this.form.deptId || undefined
        };
      },

      validate() {
        return new Promise(resolve => {
          if (!this.form.deptId) {
            this.$message({
              message: "Đơn vị bắt buộc nhập",
              type: "error"
            });
            return;
          }
          let diff;
          if (!this.form.fromDate || !this.form.toDate) {
            this.$message({
              message: "Khoảng thời gian (từ ngày/đến ngày) bắt buộc nhập",
              type: "error"
            });
            return;
          }
          let fromDate = dateUtils.toMoment(this.form.fromDate);
          let toDate = dateUtils.toMoment(this.form.toDate);
          diff = toDate.diff(fromDate, "day");
          if (diff < 0) {
            this.$message({
              message: "Trường Đến ngày không được nhỏ hơn trường tới ngày",
              type: "error"
            });
            return;
          }
          if (diff > 365) {
            this.$message({
              message: "Khoảng thời gian phải nhỏ hơn 1 năm",
              type: "error"
            });
            return;
          }
          resolve();
        });
      },

      storeParamsAtUrl() {
        let query = this.buildQuery();

        let routerQuery = utils.merge(this.$router.query, {
          fromDate: query.fromDate,
          toDate: query.toDate,
          reportType: this.reportType
        });

        this.$router.replace({
          name: this.$router.name,
          params: this.$router.params,
          query: routerQuery
        });
      },

      convertToFilterForm() {
        return {
          fromDate: this.form.fromDate,
          toDate: this.form.toDate,
          deptId: this.form.deptId === "all" ? null : this.form.deptId,
          deptIds:
            this.form.deptId === "all"
              ? h.collect(this.departments_, item => item.id)
              : null,
          sort: this.sort,
          order: this.order,
          taskStatusList: this.status ? this.status : [],
        };
      },

      exportReport() {
        // this.sort = null;
        // this.order = null;
        return this.validate().then(() => {
          this.storeParamsAtUrl();
          return tkTaskViewService
            .baoCaoTongHopThang(this.convertToFilterForm())
            .then(response => (this.items = response.data));
        });
      },

      exportReportExcel() {
        this.exportReport().then(() => {
          let query = utils.merge(this.convertToFilterForm(), {
            userDeptRoleId: this.userDeptRoleId
          });
          let baseServiceURL = constants.BASE_SERVICE_URL;
          let reportUrl = constants.REPORT.QLCV.URL.BAOCAOTONGHOPTHANG;
          window.open(
            `${baseServiceURL}${reportUrl}?${utils.serialize(query)}`,
            "_blank "
          );
        });
      }
    }
  };
</script>

<style scoped>
  .barChart {
    margin-top: 20px;
    height: calc(100% - 100px) !important;
    width: calc(100% - 10px) !important;
    position: relative;
  }

  .break-word {
    word-break: break-word;
  }
</style>



// WEBPACK FOOTER //
// src/views/report/qlcv/bao-cao-tong-hop-thang.vue